module.exports = __webpack_public_path__ + "school/img/jiaoshisanji.d05c3fe8.jpg";